// app/javascript/controllers/mobile_nav_viewport_adjust_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
//    console.log("MobileNavViewportAdjustController connected to:", this.element);
    this.dropdownToggles = this.element.querySelectorAll('.nav-item.dropdown > .dropdown-toggle');
//    console.log(`Found ${this.dropdownToggles.length} dropdown toggles.`);

    this.boundHandleDropdownShow = this.handleDropdownShow.bind(this);
    this.boundActivateOverlay = this.activateOverlay.bind(this);
    this.boundDeactivateOverlay = this.deactivateOverlay.bind(this);

    this.element.addEventListener('show.bs.collapse', this.boundActivateOverlay);
    this.element.addEventListener('hide.bs.collapse', this.boundDeactivateOverlay);

    this.dropdownToggles.forEach(toggle => {
      toggle.addEventListener('show.bs.dropdown', this.boundHandleDropdownShow);
    });

    if (this.element.classList.contains('show')) {
      this.activateOverlay();
    }
  }

  disconnect() {
//    console.log("MobileNavViewportAdjustController disconnected.");
    this.element.removeEventListener('show.bs.collapse', this.boundActivateOverlay);
    this.element.removeEventListener('hide.bs.collapse', this.boundDeactivateOverlay);

    this.dropdownToggles.forEach(toggle => {
      toggle.removeEventListener('show.bs.dropdown', this.boundHandleDropdownShow);
    });
    this.deactivateOverlay();
  }

  activateOverlay() {
//    console.log("Activating mobile menu overlay.");
    document.body.classList.add('mobile-menu-active');
    this.element.classList.add('is-overlay');
  }

  deactivateOverlay() {
//    console.log("Deactivating mobile menu overlay.");
    document.body.classList.remove('mobile-menu-active');
    this.element.classList.remove('is-overlay');
  }

  handleDropdownShow(event) {
    const toggler = event.target;
    const overlayElement = this.element; // This is #mobileNavbarCollapse

//    console.log("%cDropdown show in overlay for:", "color: blue; font-weight: bold;", toggler);

    if (!overlayElement.classList.contains('is-overlay')) {
      console.warn("Overlay not active, aborting dropdown scroll adjust.");
      return;
    }

    // Use requestAnimationFrame to ensure layout is stable before measurements
    requestAnimationFrame(() => {
//      console.log("%cInside requestAnimationFrame", "color: green;");

      const overlayRect = overlayElement.getBoundingClientRect();
      const togglerRect = toggler.getBoundingClientRect();

      // Calculate the toggler's top position relative to the overlay's content area.
      // This is how far down the toggler is from the top of the overlay's *visible* part.
      const togglerTopRelativeToOverlayViewportBox = togglerRect.top - overlayRect.top;

      const currentOverlayScrollTop = overlayElement.scrollTop;
      const overlayClientHeight = overlayElement.clientHeight; // Visible height of the overlay

      // This is the toggler's actual position from the very top of the scrollable content.
      const togglerAbsoluteTopInScrollableContent = currentOverlayScrollTop + togglerTopRelativeToOverlayViewportBox;

//      console.log("Overlay Rect (top, height):", overlayRect.top, overlayRect.height);
//      console.log("Toggler Rect (top, height):", togglerRect.top, togglerRect.height);
//      console.log("Toggler top relative to Overlay's viewport box:", togglerTopRelativeToOverlayViewportBox);
//      console.log("Overlay current scrollTop:", currentOverlayScrollTop);
//      console.log("Overlay clientHeight (visible height):", overlayClientHeight);
//      console.log("Toggler's absolute top in scrollable content:", togglerAbsoluteTopInScrollableContent);

      // Define a threshold: if the *top* of the toggle is in the lower, say, 50% of the overlay's visible area.
      const scrollTriggerThreshold = overlayClientHeight * 0.15;
//      console.log("Scroll Trigger Threshold (visible top > 50% of overlay height):", scrollTriggerThreshold);

      if (togglerTopRelativeToOverlayViewportBox > scrollTriggerThreshold) {
//        console.log("%cToggler is visually low in overlay. Scroll adjustment needed.", "color: orange;");

        // Aim to bring the toggler's top to about 15% from the top of the overlay's visible area.
        const desiredTogglerTopInOverlayVisibleArea = overlayClientHeight * 0.15;
//        console.log("Desired Toggler Top in Overlay's Visible Area (15% from top):", desiredTogglerTopInOverlayVisibleArea);

        // Calculate the new scrollTop value for the overlayElement.
        // This is: current scroll position + how much further down the toggle is than desired.
        // Or, simpler: the toggler's absolute position in the scrollable content minus the desired visible offset.
        let newScrollTop = togglerAbsoluteTopInScrollableContent - desiredTogglerTopInOverlayVisibleArea;

        // Ensure newScrollTop is not negative and not beyond the max scroll.
        newScrollTop = Math.max(0, newScrollTop);
        newScrollTop = Math.min(newScrollTop, overlayElement.scrollHeight - overlayClientHeight); // Prevent overscrolling

//        console.log("Current overlay scrollTop before scroll:", currentOverlayScrollTop);
//        console.log("Calculated target newScrollTop for overlay:", newScrollTop);

        if (Math.abs(newScrollTop - currentOverlayScrollTop) < 1) { // If effectively no change
//            console.log("Calculated newScrollTop is very close to current. No scroll action taken.");
            return;
        }
        
        // --- TEST SCROLL ---
        // Forcing an obvious scroll for testing:
//        // console.log("--- FORCING SCROLL TEST ---");
        // overlayElement.scrollTo({ top: currentOverlayScrollTop + 100, behavior: 'auto' });
        // setTimeout(() => {
//        //     console.log("Overlay scrollTop after FORCED scroll test:", overlayElement.scrollTop);
        // }, 350);
        // return; // End here for forced scroll test
        // --- END FORCING SCROLL TEST ---


        overlayElement.scrollTo({
          top: newScrollTop,
          behavior: 'smooth' // Try 'auto' first for testing if 'smooth' is an issue
        });

        // Log scrollTop after a short delay to see if it actually changed
        // (smooth scroll takes time, 'auto' would be immediate)
        // For 'auto', this timeout might still be useful to see the final value after other potential browser updates.
        setTimeout(() => {
//          console.log("%cOverlay scrollTop after 300ms delay:", "color: purple; font-weight: bold;", overlayElement.scrollTop);
        }, 350);

      } else {
//        console.log("Toggler is high enough in overlay. No scroll adjustment needed.");
      }
//      console.log("--- End of requestAnimationFrame ---");
    });
//    console.log("--- End of handleDropdownShow for " + toggler.textContent.trim() + " ---");
  }
}